module.exports = __webpack_public_path__ + "static/media/radio-2.43810451.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/radio-2.svg
// module id = 968
// module chunks = 0